import { createBrowserRouter, Navigate } from 'react-router';
import { LoginPage, RequireAuth } from '@features/auth';
import { AiPage, aiRoutes } from '@features/ai';
import { dashboardRoutes } from '@features/dashboard';
import { ReceiptsPage, receiptsRoutes } from '@features/receipts';
import { settingsRoutes } from '@features/settings';
import { paths } from '@shared/config/paths';
import { AppLayout } from '../layouts/AppLayout';
import { NotFoundPage } from '../pages/NotFoundPage';

/**
 * Routeur de la coquille applicative.
 * /login est publique ; tout le reste est protégé par RequireAuth.
 * Chaque feature expose ses routes via son API publique (@features/<nom>).
 * `/expenses` et `/analytics` sont des alias lisibles vers receipts et ai.
 */
export const router = createBrowserRouter([
  { path: paths.login, element: <LoginPage /> },
  {
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { path: paths.home, element: <Navigate to={paths.dashboard} replace /> },
      ...dashboardRoutes,
      ...receiptsRoutes,
      { path: paths.expenses, element: <ReceiptsPage /> },
      { path: paths.analytics, element: <AiPage /> },
      ...aiRoutes,
      ...settingsRoutes,
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
